import config from "@/lib/config";
import { useDeviceInfoQuery } from "@/hooks";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AndroidAppDownloadBanner() {
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const {
    isAndroid
  } = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {};
  if (!isAndroid) return null;
  const href = config.appStoreUrl.android;
  return /*#__PURE__*/_jsx("a", {
    className: styles["getin-googleplay"],
    href: href,
    children: /*#__PURE__*/_jsx("img", {
      alt: "Google Play \u3067\u624B\u306B\u5165\u308C\u3088\u3046",
      src: "/images/google_play_badge.png"
    })
  });
}